import React, { useState, useEffect } from 'react';
import './CompteARebourd.css';

interface CompteARebourdProps {
  targetDate: string; // Format: "2025-10-08 13:48:55"
  // Pour garder la compatibilité avec le code existant
  initialTime?: string; 
}

const CompteARebourd: React.FC<CompteARebourdProps> = ({ targetDate, initialTime }) => {
  const [timeLeft, setTimeLeft] = useState<number>(() => {
    if (targetDate) {
      return calculateTimeLeft(targetDate);
    } else if (initialTime) {
      return parseTimeString(initialTime);
    }
    return 0;
  });

  useEffect(() => {
    const timer = setInterval(() => {
      if (targetDate) {
        setTimeLeft(calculateTimeLeft(targetDate));
      } else {
        setTimeLeft(prevTime => {
          if (prevTime <= 0) return 0;
          return prevTime - 1;
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const formatTime = (seconds: number): string => {
    const days = Math.floor(seconds / (24 * 3600));
    const hours = Math.floor((seconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return `${days}j ${hours}h ${minutes}m ${secs}s`;
  };

  const getUrgencyLevel = (seconds: number): string => {
    const days = Math.floor(seconds / (24 * 3600));
    if (seconds <= 0) return 'expired';
    if (days <= 2) return 'urgent';
    if (days <= 6) return 'warning';
    if (days <= 90) return 'normal';
    return '';
  };

  return (
    <div className={`countdown ${getUrgencyLevel(timeLeft)}`}>
      {formatTime(timeLeft)}
    </div>
  );
};

// Helper function to parse time string into seconds
const parseTimeString = (timeStr: string): number => {
  const parts = timeStr.split(' ');
  let totalSeconds = 0;

  parts.forEach(part => {
    const value = parseInt(part);
    if (part.endsWith('j')) totalSeconds += value * 24 * 3600;
    if (part.endsWith('h')) totalSeconds += value * 3600;
    if (part.endsWith('m')) totalSeconds += value * 60;
    if (part.endsWith('s')) totalSeconds += value;
  });

  return totalSeconds;
};

// Calculate time left in seconds between now and target date
const calculateTimeLeft = (targetDateStr: string): number => {
  const now = new Date();
  const targetDate = new Date(targetDateStr);
  
  // Calculate difference in seconds
  const differenceInSeconds = Math.floor((targetDate.getTime() - now.getTime()) / 1000);
  
  // Return 0 if the target date is in the past
  return differenceInSeconds > 0 ? differenceInSeconds : 0;
};

export default CompteARebourd;